import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
  SimpleChanges
} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup
} from '@angular/forms';
import { UserDataService } from '@com-delta-idp/mnx-oauth';
import { LoggingService } from '@com-delta-idp/mnx-utils';
import { Store } from '@ngrx/store';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Observable, Subject, Subscription, combineLatest } from 'rxjs';
import {
  debounceTime,
  distinctUntilChanged,
  startWith,
  take,
  takeUntil
} from 'rxjs/operators';
import { CookieHelper } from '../../common/cookie-helper';
import { DeviceTypeHelper } from '../../common/device-type-helper';
import { ApplicationConfig } from '../../config/config';
import { ICorporatePartner } from '../../corporate-partner/corporate-partner.interface';
import { AirportLookupModel } from '../../model/airport-lookup.model';
import { BookParameters } from '../../model/bookparameter.model';
import { ContentBook } from '../../model/content/contentbook.model';
import { UPDATE_FORM } from '../../model/forms.model';
import { GetSavedTrips } from '../../model/get-saved-trips/get-saved-trips.interfaces';
import { RecentSearch } from '../../model/recent-search.model';
import { SavedsearchesModel } from '../../model/savedsearches.model';
import { TrackerDataService } from '../../services/acctactvty/trackerData.service';
import { ClosestAirPortcode } from '../../services/closestairportcode.service';
import { CommonService } from '../../services/common.service';
import { ContentHeaderFooterService } from '../../services/content/contentheaderfooter.service';
import { GetSavedTripsService } from '../../services/get-saved-trips/get-saved-trips.service';
import { MobileWidgetModalComponent } from './mobile-widget-modal.component';

@Component({
  selector: 'ngc-mobile-widget',
  templateUrl: 'mobile-widget.component.html'
})
export class MobileWidgetComponent
  implements OnInit, AfterViewInit, OnChanges, OnDestroy
{
  savedSelected: any;
  recentSelected: any;
  recentSearches: RecentSearch[] = [];
  savedSearches: SavedsearchesModel;
  savedSearch = false;
  recentSearch = false;
  savedSearchesAvailable = false;
  recentSearchsAvailable = false;
  prefCityCheck = false;
  contentServiceHeaderFooterSubscribe: Subscription;
  trackerServiceRecentSearchesSubscribe: Subscription;
  trackerServiceSavedSearchesSubscribe: Subscription;
  srvClosestDeltaAirportCodeSubscribe: Subscription;
  @Input() selectedNavItem: string;
  @Input() prefCity: string;
  @Input() custId;
  @Input() isEDPFlag;
  @Input() mkcpgn: string;
  @Input() corpPartner: ICorporatePartner;
  @Input() queryParam: BookParameters;
  @Input() darkSiteLevel: string;

  // tslint:disable-next-line:no-output-on-prefix
  @Output() onToAirportSearched: EventEmitter<string> = new EventEmitter();
  // tslint:disable-next-line:no-output-on-prefix
  @Output() onFromAirportSearched: EventEmitter<string> = new EventEmitter();
  preferredCity = '';
  selectTripType = 'roundTrip';
  fromAirportcode = '';
  fromCity = '';
  fromCountryCode = '';
  toCountryCode = '';
  swapedFromCity = '';
  swapedToCity = '';
  toAirportcode = '';
  toCity = '';
  recentSearchSelected: any;
  prefCityVal = '';
  fromClosestAirportcode: any;
  fromClosestCity: string;
  preferredCityChecked: boolean;
  customerId: string;
  public fromAndToAirport: any;
  bsModalRef: BsModalRef;
  isClosed = false;
  modalOnHiddenSubscription: Subscription;
  config = {
    animated: false
  };

  content: ContentBook;
  public deviceTypes: any = [];
  fromAirportLabel = '';
  toAirportLabel = ' ';
  deviceTypeSubscribe: Subscription;
  bookWidgetForm: UntypedFormGroup;
  path = 'bookWidgetForm';
  formValueRef = {};
  formValueChangeSubscription: any;
  storesubsciption = null;
  formisBeingWrittenByModalWidget = false;
  date: any;
  airport: any;
  private unsubscribe: Subject<void> = new Subject();
  showNewProfileSelector = false;
  isBusiness = false;
  getSavedTripsFlag = false;

  constructor(
    private modalService: BsModalService,
    private cdf: ChangeDetectorRef,
    private srv: CommonService,
    private srvClosestAirport: ClosestAirPortcode,
    private contentService: ContentHeaderFooterService,
    private trackerDataService: TrackerDataService,
    private store: Store<any>,
    private formBuilder: UntypedFormBuilder,
    private _deviceTypeHelper: DeviceTypeHelper,
    private configObj: ApplicationConfig,
    private rend: Renderer2,
    private cookieHelper: CookieHelper,
    private loggingService: LoggingService,
    private getSaveTrips: GetSavedTripsService,
    private userData: UserDataService
  ) {}

  ngOnInit() {
    if (this.configObj.onBrowser) {
      this.setRecentSearchesAirport();
    }
    this.bookWidgetForm = this.formBuilder.group({
      airports: this.formBuilder.group({
        fromCity: new UntypedFormControl({ value: this.fromCity }),
        toCity: new UntypedFormControl({ value: this.toCity }),
        fromAirportcode: new UntypedFormControl({
          value: this.fromAirportcode
        }),
        toAirportcode: new UntypedFormControl({ value: this.toAirportcode }),
        fromCountryCode: new UntypedFormControl(this.fromCountryCode),
        toCountryCode: new UntypedFormControl(this.toCountryCode)
      })
    });
    // this.setRecentSearchesAirport();
    let tempValueRef;
    this.store
      .select((state) => state.formReducer['bookWidgetForm'])
      .pipe(take(1))
      .subscribe(
        (formValue) => {
          if (formValue) {
            tempValueRef = formValue;
            this.fromAirportcode = formValue.airports
              ? formValue.airports.fromAirportcode
              : this.fromAirportcode;
            this.fromCity = formValue.airports
              ? formValue.airports.fromCity
              : this.fromCity;
            this.toAirportcode = formValue.airports
              ? formValue.airports.toAirportcode
              : this.toAirportcode;
            this.toCity = formValue.airports
              ? formValue.airports.toCity
              : this.toCity;
            if (
              this.fromAirportcode === '' &&
              this.fromClosestAirportcode !== ''
            ) {
              this.fromAirportcode = this.fromClosestAirportcode;
              this.fromCity = this.fromClosestCity;
            }
            this.fromCountryCode = formValue.airports
              ? formValue.airports.fromCountryCode
              : this.fromCountryCode;
            this.toCountryCode = formValue.airports
              ? formValue.airports.toCountryCode
              : this.toCountryCode;
          }
        },
        (err) => {
          if (this.configObj.onBrowser) {
            this.loggingService.log('Caught Error: ' + err);
          }
        }
      );
    this.formValueChangeSubscription = combineLatest(
      [this.bookWidgetForm.valueChanges].map((obs) =>
        obs.pipe(startWith(null as string))
      )
    )
      .pipe(
        debounceTime(100),
        distinctUntilChanged(
          (prev, curr) => JSON.stringify(prev[0]) === JSON.stringify(curr[0])
        ),
        takeUntil(this.unsubscribe)
      )
      .subscribe(
        (value) => {
          this.updatedFullState(tempValueRef, value[0]);
          this.store.dispatch({
            type: UPDATE_FORM,
            payload: {
              value: this.formValueRef,
              path: this.path
            }
          });
        },
        (err) => {
          if (this.configObj.onBrowser) {
            this.loggingService.log('Caught Error: ' + err);
          }
        }
      );
    if (this.contentService.contentHeaderFooter) {
      this.contentServiceHeaderFooterSubscribe =
        this.contentService.contentHeaderFooter
          .pipe(takeUntil(this.unsubscribe))
          .subscribe(
            (data) => {
              if (data) {
                this.showNewProfileSelector =
                  !!data?.header?.enableNewProfileSelector;
                if (this.showNewProfileSelector) {
                  const accountCookie =
                    this.cookieHelper.getCookieValue('account');
                  if (accountCookie && accountCookie.length) {
                    const accountCookieJson = JSON.parse(accountCookie);
                    if (accountCookieJson['isBusiness']) {
                      this.isBusiness = true;
                    }
                  }
                }
                this.content =
                  data.header.primaryNavigations.get('book').details;
                this.setAemValues();
              }
            },
            (err) => {
              this.loggingService.log('Caught Error: ' + err);
            }
          );
    }
    if (this.configObj.onBrowser) {
      this.deviceTypeSubscribe = this._deviceTypeHelper
        .deviceDetection()
        .pipe(takeUntil(this.unsubscribe))
        .subscribe((resp) => {
          this.deviceTypes = resp;
        });
    }

    this.getSavedTripsFeatureFlag();
  }

  setAemValues() {
    this.fromAirportLabel = this.content.fromLabel;
    this.toAirportLabel = this.content.toLabel;
  }

  displayRecentSearch(val) {
    this.setRecentSearchResults(val);
    this.recentSelected = val;
  }

  setSaved(val) {
    this.fromAirportcode = val.origDestInfos[0].originCityCd;
    this.fromCity = '';
    this.toAirportcode = val.origDestInfos[0].destinationCityCd;
    this.toCity = '';
    this.setFromAirport(
      new AirportLookupModel(this.fromAirportcode, this.fromCity, '', '', '')
    );
    this.setToAirport(
      new AirportLookupModel(this.toAirportcode, this.toCity, '', '', '')
    );
    this.savedSelected = val;
  }

  async setRecentSearchesAirport() {
    this.trackerServiceRecentSearchesSubscribe = this.trackerDataService
      .getRecentSearches()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        (res) => {
          if (res !== null && res !== undefined && res !== '') {
            if (res.length > 0) {
              res.forEach((resp, index) => {
                // if (this.checkForpastDate(resp.dates.departureDate)) {
                this.recentSearches.push(new RecentSearch(resp));
                // }
              });
              if (this.recentSearches.length > 0) {
                this.recentSearchSelected = this.recentSearches[0];
                this.recentSearchsAvailable = true;
                if (this.bookWidgetForm) {
                  this.setDisplayValues();
                }
              }
            } else if (this.bookWidgetForm) {
              this.setDisplayValues();
            }
          }
        },
        (err) => {
          this.loggingService.log('Caught Error: ' + err);
        }
      );
  }

  getSavedTripsFeatureFlag() {
    try {
      this.userData.getAuthConfigContent().subscribe((response) => {
        if (response && response['GET_SAVED_TRIPS_AWS_API_FLAG'] === true) {
          this.getSavedTripsFlag = response['GET_SAVED_TRIPS_AWS_API_FLAG'];
        } else {
          this.getSavedTripsFlag = false;
        }
      });
    } catch (error) {
      this.loggingService.log(
        'Error Reading GET_SAVED_TRIPS_AWS_API_FLAG Feature Flags'
      );
    }
  }

  getSavedResponse(custId): Observable<any | GetSavedTrips> {
    if (this.getSavedTripsFlag) {
      return this.getSaveTrips.getSavedTrips();
    } else {
      return this.trackerDataService.getSavedSearches(custId);
    }
  }

  setSavedSearchesAirport(custId) {
    if (custId !== undefined && custId !== '') {
      this.trackerServiceSavedSearchesSubscribe = this.getSavedResponse(custId)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(
          (res) => {
            if (res !== null && res !== undefined && res !== '') {
              if (
                res.customer !== undefined &&
                res.customer !== null &&
                res.customer.savedTripList !== undefined &&
                res.customer.savedTripList !== null
              ) {
                if (res.customer.savedTripList.length > 0) {
                  this.savedSearchesAvailable = true;
                  this.savedSearches = new SavedsearchesModel(res);
                  if (this.bookWidgetForm) {
                    this.setDisplayValues();
                  }
                }
              } else if (this.bookWidgetForm) {
                this.setDisplayValues();
              }
            } else if (this.bookWidgetForm) {
              this.setDisplayValues();
            }
          },
          (err) => {
            this.savedSearch = false;
            if (this.bookWidgetForm) {
              this.setDisplayValues();
            }
          }
        );
    } else if (this.bookWidgetForm) {
      this.setDisplayValues();
    }
  }

  ngAfterViewInit(): void {
    // this.setSavedSearchesAirport(this.customerId);
    if (this.bookWidgetForm !== undefined) {
      this.cdf.detectChanges();
    }
  }

  setDisplayValues() {
    if (this.srvClosestDeltaAirportCodeSubscribe) {
      this.srvClosestDeltaAirportCodeSubscribe.unsubscribe();
      this.srvClosestDeltaAirportCodeSubscribe = null;
    }
    if (
      this.recentSearchSelected !== null &&
      this.recentSearchSelected !== undefined
    ) {
      this.setRecentSearchResults(this.recentSearchSelected);
    } else if (
      this.savedSearches !== null &&
      this.savedSearches !== undefined
    ) {
      this.setSavedSearchResults(this.savedSearches);
    } else if (this.prefCityVal !== '' && this.prefCityVal !== undefined) {
      this.getPrefCity(this.prefCityVal);
    } else {
      if (
        !this.fromClosestAirportcode &&
        (!this.fromAirportcode || this.fromAirportcode === '') &&
        (!this.toAirportcode || this.toAirportcode === '')
      ) {
        this.setClosestAirport();
      }
    }
    if (this.bookWidgetForm !== undefined) {
      this.cdf.detectChanges();
    }
  }

  swapCity() {
    const from = this.fromAirportcode;
    const to = this.toAirportcode;
    const fromCity = this.fromCity;
    const toCity = this.toCity;
    this.fromAirportcode = to;
    this.toAirportcode = from;
    this.toCity = fromCity;
    this.fromCity = toCity;
    if (this.fromAirportcode === '') {
      this.fromCity = this.swapedFromCity;
    }
    if (this.toAirportcode === '') {
      this.toCity = this.swapedToCity;
    }
  }

  airportSelected(airportSelected) {
    this.fromAirportcode = airportSelected.airportCode;
    this.fromCity = airportSelected.airportCity;
  }

  setRecentSearchResults(recentSearchSelected) {
    if (recentSearchSelected) {
      this.recentSearchsAvailable = true;
      this.fromAirportcode = recentSearchSelected.airports.fromAirportcode;
      this.fromCity = recentSearchSelected.airports.fromCity;
      this.toAirportcode = recentSearchSelected.airports.toAirportcode;
      this.toCity = recentSearchSelected.airports.toCity;
      this.setFromAirport(
        new AirportLookupModel(this.fromAirportcode, this.fromCity, '', '', '')
      );
      this.setToAirport(
        new AirportLookupModel(this.toAirportcode, this.toCity, '', '', '')
      );
      this.recentSelected = recentSearchSelected;
    }
  }

  setSavedSearchResults(res) {
    this.fromAirportcode =
      this.savedSearches.savedTripsList[0].origDestInfos[0].originCityCd;
    this.fromCity = '';
    this.toAirportcode =
      this.savedSearches.savedTripsList[0].origDestInfos[0].destinationCityCd;
    this.toCity = '';
    this.setFromAirport(
      new AirportLookupModel(this.fromAirportcode, this.fromCity, '', '', '')
    );
    this.setToAirport(
      new AirportLookupModel(this.toAirportcode, this.toCity, '', '', '')
    );
    this.savedSelected = this.savedSearches.savedTripsList[0];
  }

  setClosestAirport() {
    this.srvClosestDeltaAirportCodeSubscribe = this.srvClosestAirport
      .getClosestDeltaAirportCode()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        (data) => {
          if (data) {
            this.fromClosestAirportcode = data.airportcode;
            this.fromClosestCity =
              data.cityname && data.statecode
                ? data.cityname + ', ' + data.statecode
                : '';
            if (this.bookWidgetForm) {
              if (
                (!this.fromAirportcode || this.fromAirportcode === '') &&
                (!this.toAirportcode || this.toAirportcode === '')
              ) {
                this.setFromAirport(
                  new AirportLookupModel(
                    this.fromClosestAirportcode,
                    this.fromClosestCity,
                    '',
                    '',
                    ''
                  )
                );
                this.setToAirport(
                  new AirportLookupModel(
                    this.toAirportcode,
                    this.toCity,
                    '',
                    '',
                    ''
                  )
                );
                this.cdf.detectChanges();
              }
            }
          }
        },
        (err) => {
          this.fromClosestAirportcode = '';
          this.fromClosestCity = '';
        }
      );
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.prefCity) {
      if (this.prefCity !== undefined) {
        this.prefCityVal = this.prefCity;
      }
    }
    if (changes.custId) {
      if (this.custId !== undefined) {
        if (this.custId !== this.customerId) {
          this.customerId = this.custId;
        }
      }
    }
  }

  openBookWidgetInModal(event?: AirportLookupModel) {
    if (event && event.airportCode && event.airportCode.trim() !== '') {
      this.expandBookWidgetInModal();
    }
  }

  expandBookWidgetInModal() {
    this.selectedNavItem = 'book';
    this.cdf.detectChanges();
    this.openMobileWidgetModal();
  }

  setFromAirport(event: AirportLookupModel) {
    if (event) {
      this.fromAirportcode = event.airportCode;
      const fCity = event.city && event.city.trim() !== '' ? event.city : '';
      const fRegion =
        event.region && event.region.trim() !== '' ? event.region : '';
      let fCityFull =
        fCity !== '' && fRegion !== ''
          ? fCity + ', ' + fRegion
          : fCity + '' + fRegion;
      if (
        this.content &&
        (!this.fromAirportcode || this.fromAirportcode.trim() === '') &&
        fCityFull.trim() === ''
      ) {
        fCityFull = this.content.travelOrigin;
      }
      this.fromCity = fCityFull;
      this.fromCountryCode = event.countryCode;
      this.formValueRef['airports'] ??= {};
      this.formValueRef['airports'].fromAirportcode = this.fromAirportcode;
      this.formValueRef['airports'].fromCity = this.fromCity;
      this.formValueRef['airports'].fromCountryCode = this.fromCountryCode;
    }
  }

  setToAirport(event) {
    if (event) {
      this.toAirportcode = event.airportCode;
      this.airport = event;
      const tCity = event.city && event.city.trim() !== '' ? event.city : '';
      const fRegion =
        event.region && event.region.trim() !== '' ? event.region : '';
      let tCityFull =
        tCity !== '' && fRegion !== ''
          ? tCity + ', ' + fRegion
          : tCity + '' + fRegion;
      if (
        this.content &&
        (!this.toAirportcode || this.toAirportcode.trim() === '') &&
        tCityFull.trim() === ''
      ) {
        tCityFull = this.content.travelDestinationLabel;
      }
      this.toCity = tCityFull;
      this.toCountryCode = event.countryCode;
      this.formValueRef['airports'] ??= {};
      this.formValueRef['airports'].toAirportcode = this.toAirportcode;
      this.formValueRef['airports'].toCity = this.toCity;
      this.formValueRef['airports'].toCountryCode = this.toCountryCode;
    }
  }

  openMobileWidgetModal() {
    this.modalOnHiddenSubscription = this.modalService.onHidden.subscribe(
      (reason: string) => {
        if (reason === 'esc') {
          this.isClosed = true;
        }
        if (this.isClosed) {
          this.modalOnHiddenSubscription.unsubscribe();
          this.isClosed = false;
        }
        this.storesubsciption = this.store
          .select((state) => state.formReducer['bookWidgetForm'])
          .pipe(take(1))
          .subscribe(
            (formValue) => {
              if (formValue) {
                this.formValueRef = formValue;
                this.fromAirportcode = formValue.airports
                  ? formValue.airports.fromAirportcode
                  : this.fromAirportcode;
                this.fromCity = formValue.airports
                  ? formValue.airports.fromCity
                  : this.fromCity;
                this.toAirportcode = formValue.airports
                  ? formValue.airports.toAirportcode
                  : this.toAirportcode;
                this.toCity = formValue.airports
                  ? formValue.airports.toCity
                  : this.toCity;
                this.fromCountryCode = formValue.airports
                  ? formValue.airports.fromCountryCode
                  : this.fromCountryCode;
                this.toCountryCode = formValue.airports
                  ? formValue.airports.toCountryCode
                  : this.toCountryCode;
                this.cdf.detectChanges();
              }
            },
            (err) => {
              this.loggingService.log('Caught Error: ' + err);
            }
          );
      },
      (err) => {
        this.loggingService.log('Caught Error: ' + err);
      }
    );
    // DDCFB
    const initialState = {
      airport: this.airport,
      toAirportOd: this.toAirportcode
    };
    let obj = Object.assign({}, this.config, {
      class: 'mobile-widget-modal mob-modal-link',
      initialState
    });
    if (this.corpPartner.showBusinessText || this.isBusiness) {
      obj = Object.assign({}, this.config, {
        class: 'mobile-widget-modal business',
        initialState
      });
    }
    this.bsModalRef = this.modalService.show(MobileWidgetModalComponent, obj);
    this.bsModalRef.content.queryParam = this.queryParam;
    this.bsModalRef.content.mobileNav = true;
    this.bsModalRef.content.custId = this.custId;
    this.bsModalRef.content.fromAirportcode = this.fromAirportcode;
    this.bsModalRef.content.toAirportcode = this.toAirportcode;
    this.bsModalRef.content.fromCity = this.fromCity;
    this.bsModalRef.content.toCity = this.toCity;
    this.bsModalRef.content.fromCountryCode = this.fromCountryCode;
    this.bsModalRef.content.toCountryCode = this.toCountryCode;
    this.bsModalRef.content.isEDPFlag = this.isEDPFlag;
    this.bsModalRef.content.prefCity = this.prefCity;
    this.bsModalRef.content.toggleContent(this.selectedNavItem);
    this.bsModalRef.content.isMobile = this.deviceTypes.isMobile ? true : false;
    this.bsModalRef.content.savedSelected = this.savedSelected;
    this.bsModalRef.content.recentSelected = this.recentSelected;
    this.bsModalRef.content.mkcpgn = this.mkcpgn;
    // document.getElementsByTagName('html')[0].setAttribute('class', 'no-scroll fresh-air');
    if (this.configObj.get('APP_DISABLE_LEGACY') === 'false') {
      this.rend.addClass(document.getElementsByTagName('html')[0], 'no-scroll');
      this.rend.addClass(
        document.getElementsByTagName('modal-container')[0],
        'fresh-air ' + this.darkSiteLevel
      );
    } else {
      document
        .getElementsByTagName('html')[0]
        .setAttribute('class', 'no-scroll fresh-air');
      this.rend.addClass(
        document.getElementsByTagName('modal-container')[0],
        this.darkSiteLevel
      );
    }
  }

  close() {
    this.isClosed = true;
  }

  getPrefCity(flag) {
    this.prefCityVal = flag;
    if (this.prefCityVal !== '' && this.prefCityVal !== undefined) {
      this.fromAirportcode = this.prefCityVal;
      this.fromCity = '';
      this.preferredCityChecked = true;
    }
  }

  updatedFullState(tempValueRef, value) {
    if (Object.isFrozen(tempValueRef)) {
      tempValueRef = { ...tempValueRef };
    }
    for (const controlName of Object.keys(value)) {
      Object.defineProperty(tempValueRef, controlName, {
        writable: true,
        configurable: true
      });
      const isAssignable = Object.getOwnPropertyDescriptor(
        tempValueRef,
        controlName
      );
      if (isAssignable && isAssignable.configurable) {
        tempValueRef[controlName] = value[controlName];
      }
    }
    this.formValueRef = tempValueRef;
    return this.formValueRef;
  }

  ngOnDestroy() {
    if (this.formValueChangeSubscription) {
      this.formValueChangeSubscription.unsubscribe();
    }
    if (this.storesubsciption) {
      this.storesubsciption.unsubscribe();
    }
    if (this.modalOnHiddenSubscription) {
      this.modalOnHiddenSubscription.unsubscribe();
    }
    if (this.contentServiceHeaderFooterSubscribe) {
      this.contentServiceHeaderFooterSubscribe.unsubscribe();
    }
    if (this.trackerServiceRecentSearchesSubscribe) {
      this.trackerServiceRecentSearchesSubscribe.unsubscribe();
    }
    if (this.trackerServiceSavedSearchesSubscribe) {
      this.trackerServiceSavedSearchesSubscribe.unsubscribe();
    }
    if (this.srvClosestDeltaAirportCodeSubscribe) {
      this.srvClosestDeltaAirportCodeSubscribe.unsubscribe();
    }
    this.unsubscribe.next();
    this.unsubscribe.complete();
    this.unsubscribe.unsubscribe();
    if (this.deviceTypeSubscribe) {
      this.deviceTypeSubscribe.unsubscribe();
    }
    this.cdf.detach();
  }

  getSelectedDate(dd, mm, yyyy) {
    if (dd.toString().length < 2) {
      dd = '0' + dd;
    }
    if (mm.toString().length < 2) {
      mm = '0' + mm;
    }
    return mm + '/' + dd + '/' + yyyy;
  }

  // checkForpastDate(compDate: any) {
  //   this.date = new Date(this.getSelectedDate(new Date().getDate(), (new Date().getMonth() + 1), new Date().getFullYear())).getTime();
  //   let checkDate = new Date(compDate).getTime();
  //   if (checkDate >= this.date) {
  //     return true;
  //   } else return false;
  // }
}
